module.exports = __webpack_public_path__ + "static/media/badge.c99e434b.svg";